import type {HostedGameStage} from "games/gameSession";
import type {Mode} from "home/gating";
import type {CreatePhaseName} from "home/composerArrival";

/**
 * Which part of a hosted transfer the create flow is showing, for the transfer's game slot
 * (kitecorp/transferify-ui#3388). React-free.
 *
 * The slot spans the upload, a retry of the recipients' emails after the bytes are up, and the success card,
 * so one transfer keeps one game and reports one offer. An Instant transfer is `none` here: its live card holds
 * a slot of its own.
 */
export function hostedGameStage(phase: {name: CreatePhaseName; mode?: Mode}): HostedGameStage {
	if (phase.mode !== "upload") {
		return "none";
	}
	switch (phase.name) {
		case "progress":
		case "deliveryRetry":
			return "sending";
		case "success":
			return "sent";
		case "create":
		case "resume":
		case "abandoned":
			return "none";
	}
}
